import React, { useState } from 'react'
import { ContractDataDto } from '../../api/estimates/types/model'
import { Icon } from '../../shared/ui/Icon'
import { colors } from '../../shared/ui/colors'
import { ContractExpandedDetails } from './ContractExpandedDetails'
import {
  DetailsContainer,
  ContractIconContainer,
  ContractTableRow,
  ContractTableRowWrapper,
  TotalSummaryRow
} from './ContractDetails.styles'
import {
  CompanyCell,
  CompanyName,
  CompanyDetails,
  DataCell,
  DataLabel,
  DataValue,
  DataBreakdown,
  BreakdownItem,
  ArrowIcon
} from './EstimateTable.styles'

interface ContractDetailsProps {
  contracts: ContractDataDto[]
}

const formatAmount = (amount: number): string => {
  return (
    new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount) + ' ₽'
  )
}

const calculateContractPayments = (contract: ContractDataDto): number => {
  return contract.acts.reduce((sum, act) => {
    return sum + (act.payment || 0)
  }, 0)
}

export const ContractDetails: React.FC<ContractDetailsProps> = ({
  contracts
}) => {
  const [expandedContracts, setExpandedContracts] = useState<Set<string>>(
    new Set()
  )

  const toggleContract = (contractGuid: string) => {
    setExpandedContracts(prev => {
      const newSet = new Set(prev)
      if (newSet.has(contractGuid)) {
        newSet.delete(contractGuid)
      } else {
        newSet.add(contractGuid)
      }
      return newSet
    })
  }

  const totalByActs = contracts.reduce((sum, contract) => {
    return sum + (contract.totalByActs?.total || 0)
  }, 0)

  const totalByActsWork = contracts.reduce((sum, contract) => {
    return sum + (contract.totalByActs?.work || 0)
  }, 0)

  const totalByActsMaterial = contracts.reduce((sum, contract) => {
    return sum + (contract.totalByActs?.material || 0)
  }, 0)

  return (
    <DetailsContainer>
      {contracts.map(contract => {
        const isExpanded = expandedContracts.has(contract.guid)
        const contractDate = contract.pdcs?.[0]?.date
          ? new Date(contract.pdcs[0].date).toLocaleDateString('ru-RU')
          : undefined
        const contractPayments = calculateContractPayments(contract)

        return (
          <ContractTableRowWrapper key={contract.guid}>
            <ContractTableRow
              onClick={() => toggleContract(contract.guid)}
              $isClickable
            >
              <CompanyCell>
                <ContractIconContainer bgColor="#DBEAFE">
                  <Icon type="document" size={18} color="#155DFC" />
                </ContractIconContainer>
                <CompanyDetails>
                  <CompanyName>{contract.name || 'Договор'}</CompanyName>
                  {contract.number && (
                    <div
                      style={{ fontSize: '0.875rem', color: colors.gray600 }}
                    >
                      {contract.number}
                      {contractDate && ` от`}
                    </div>
                  )}
                  <div style={{ fontSize: '0.875rem', color: colors.gray600 }}>
                    {contractDate}
                  </div>
                </CompanyDetails>
              </CompanyCell>

              <DataCell>
                <DataLabel>
                  <Icon type="document" size={11} color="#155DFC" />
                  <span>Подписано договоров</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contract.totalByContracts.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="check-document" size={11} color="#00A63E" />
                  <span>В процессе согласования</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contract.inApprovalProcess.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="check-document" size={11} color="#9810FA" />
                  <span>Итого по актам</span>
                </DataLabel>
                <DataValue>
                  {formatAmount(contract.totalByActs.total)}
                </DataValue>
              </DataCell>

              <DataCell>
                <DataLabel>
                  <Icon type="dollar" size={11} color="#F54900" />
                  <span>Итого оплат</span>
                </DataLabel>
                <DataValue>{formatAmount(contractPayments)}</DataValue>
                <DataBreakdown>
                  <BreakdownItem>
                    Распред. письма: {formatAmount(contractPayments)}
                  </BreakdownItem>
                </DataBreakdown>
                <ArrowIcon>
                  <Icon
                    type={isExpanded ? 'chevron_up' : 'chevron_down'}
                    size={20}
                    color={colors.gray600}
                  />
                </ArrowIcon>
              </DataCell>
            </ContractTableRow>
            {isExpanded && <ContractExpandedDetails contract={contract} />}
          </ContractTableRowWrapper>
        )
      })}
      {/* <TotalSummaryRow>
        <DataCell>
          <DataLabel>
            <Icon type='dollar' size={11} color='#F54900' />
            <span>Платежи</span>
          </DataLabel>
          <DataValue>{formatAmount(0)}</DataValue>
          <DataBreakdown>
            <BreakdownItem>Завершено: {formatAmount(0)}</BreakdownItem>
            <BreakdownItem>Ожидается: {formatAmount(0)}</BreakdownItem>
          </DataBreakdown>
        </DataCell>
        <DataCell>
          <DataLabel>
            <Icon type='check-document' size={11} color='#9810FA' />
            <span>Итого по актам</span>
          </DataLabel>
          <DataValue>{formatAmount(totalByActs)}</DataValue>
          <DataBreakdown>
            <BreakdownItem>Работы: {formatAmount(totalByActsWork)}</BreakdownItem>
            <BreakdownItem>Материалы: {formatAmount(totalByActsMaterial)}</BreakdownItem>
          </DataBreakdown>
        </DataCell>
      </TotalSummaryRow> */}
    </DetailsContainer>
  )
}
